(() => {
  const root=document.querySelector('[data-ak-about]');
  if(!root) return;
  const desktop=matchMedia('(min-width:1201px)');
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  const panel=root.querySelector('.ak-about__panel');
  const portrait=root.querySelector('.ak-about__portrait');
  const copy=root.querySelector('.ak-about__copy');
  const counter=root.querySelector('[data-ak-about-counter]');
  const chapters=Array.from(root.querySelectorAll('[data-ak-about-chapter]'));
  const title=root.querySelector('h1');
  const context=document.createElement('canvas').getContext('2d');
  function updateCounter() {
    let active=0;
    let signatureVisible=false;
    if(desktop.matches) {
      const height=root.clientHeight;
      const progress=Math.min(1,Math.max(0,root.scrollTop/height));
      root.style.setProperty('--ak-about-second-progress',progress);
      active=progress>=.55?1:0;
      const middle=root.getBoundingClientRect().top+height*.5;
      const statement=root.querySelector('.ak-about__sequence--statement');
      const fourthProgress=Math.min(1,Math.max(0,(root.scrollTop-statement.offsetTop)/height));
      root.style.setProperty('--ak-about-fourth-progress',fourthProgress);
      const fifthProgress=Math.min(1,Math.max(0,(root.scrollTop-statement.offsetTop-height)/height));
      root.style.setProperty('--ak-about-fifth-progress',fifthProgress);
      root.style.setProperty('--ak-about-fifth-push',`${fifthProgress*(height+1)}px`);
      if(statement.getBoundingClientRect().top<=middle) active=2;
      if(fourthProgress>=.55) active=3;
      if(fifthProgress>=.55) active=4;
      signatureVisible=fifthProgress>=.96;
    } else {
      const edge=45;
      const entries=[portrait,root.querySelector('.ak-about__second-image'),chapters[2],root.querySelector('.ak-about__fourth-image'),root.querySelector('.ak-about__fifth-image')];
      entries.forEach((entry,index)=>{
        if(entry && entry.getBoundingClientRect().top<=edge+2) active=index;
      });
      signatureVisible=chapters[4].getBoundingClientRect().top<=innerHeight*.5;
    }
    root.toggleAttribute('data-ak-about-signature-visible',signatureVisible);
    const label=`${String(active+1).padStart(3,'0')} / ${String(chapters.length).padStart(3,'0')}`;
    if(counter.dataset.akCounterLabel!==label) {
      counter.dataset.akCounterLabel=label;
      counter.replaceChildren(...Array.from(label, character => {
        if(character!=='1') return document.createTextNode(character);
        const digit=document.createElement('span');
        digit.className='ak-about__digit-one';
        digit.textContent=character;
        return digit;
      }));
    }
  }
  root.addEventListener('scroll',updateCounter,{passive:true});
  window.addEventListener('scroll',updateCounter,{passive:true,capture:true});
  function geometry() {
    const titleSize=getComputedStyle(title).fontSize;
    root.style.setProperty('--ak-about-counter-size',titleSize);
    if(!desktop.matches) {
      const rail=document.querySelector('.ak-site-frame-rail--left');
      const rect=rail?.getBoundingClientRect();
      root.style.setProperty('--ak-about-counter-top',`${(rect?.top ?? 45)+30}px`);
      root.style.setProperty('--ak-about-counter-left',`${(rect?.right ?? root.getBoundingClientRect().left)+30}px`);
      updateCounter();
      return;
    }
    const menu=document.querySelector('.ak-bottom-nav .ak-bottom-menu-box');
    const rect=root.getBoundingClientRect();
    if(menu) root.style.setProperty('--ak-about-split',`${menu.getBoundingClientRect().left-rect.left}px`);
    const upperGrid=document.querySelector('.ak-site-frame-rail--left .ak-site-frame-rail__grid--top');
    if(upperGrid) {
      const stroke=upperGrid.getBoundingClientRect().bottom-1;
      root.style.setProperty('--ak-about-fifth-copy-height',`${Math.max(1,rect.bottom-stroke)}px`);
    }
    // Measure the ink, so the actual numerals sit 30px from both edges.
    let inset=0,leftInset=0;
    if(context) {
      const style=getComputedStyle(counter);
      context.font=`${style.fontWeight} ${titleSize} Helvetica,Arial,sans-serif`;
      const ink=context.measureText('001 / 005');
      const size=parseFloat(titleSize);
      const ascent=ink.fontBoundingBoxAscent || size*.8;
      const descent=ink.fontBoundingBoxDescent || size*.2;
      inset=(size-ascent-descent)/2+ascent-ink.actualBoundingBoxAscent;
      leftInset=ink.actualBoundingBoxLeft || 0;
    }
    root.style.setProperty('--ak-about-counter-top',`${rect.top+30-inset}px`);
    root.style.setProperty('--ak-about-counter-left',`${rect.left+30+leftInset}px`);
    updateCounter();
  }
  new ResizeObserver(geometry).observe(root);
  window.addEventListener('resize',geometry,{passive:true});
  async function enter() {
    if(!document.body.classList.contains('ak-global-frame-complete')) await new Promise(resolve=>window.addEventListener('ak:global-frame-ready',resolve,{once:true}));
    await document.fonts.ready;
    geometry();
    if(!reduced.matches && !document.documentElement.classList.contains('ak-carousel-page-revisit')) {
      const fade=portrait.animate([{opacity:0},{opacity:1}],{duration:650,easing:'ease',fill:'both'});
      await fade.finished.catch(()=>{});
      const slide=panel.animate([{transform:'translateX(100%)',visibility:'visible'},{transform:'translateX(0)',visibility:'visible'}],{duration:1100,easing:'cubic-bezier(.45,0,.2,1)',fill:'both'});
      await slide.finished.catch(()=>{});
      const rise=copy.animate([{opacity:0,transform:'translateY(32px)'},{opacity:1,transform:'translateY(0)'}],{duration:700,easing:'cubic-bezier(.22,1,.36,1)',fill:'both'});
      await rise.finished.catch(()=>{});
      root.dataset.akAboutEntry='done';
      [fade,slide,rise].forEach(animation=>animation.cancel());
    } else root.dataset.akAboutEntry='done';
  }
  enter();
})();
